import type { Incident } from '../../../../../types';
import { Status } from '../../../../../types';
import type { INCIDENT_COLORS } from '../config/incidentColors';

export const getColor = (incident: Incident): keyof typeof INCIDENT_COLORS =>
  incident.status === Status.RESOLVED ? 'Grey' : incident.resolutionLevel;
